function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useRef, useEffect } from 'react';
import dynamic from 'next/dynamic';
import Card from 'components/cards/Card';
import { Stack, View } from 'tamagui';
import { EvilChevronLeft, EvilChevronRight } from 'components/utility/General';
import { slugify } from 'app/utils/misc';
import 'glider-js/glider.min.css';
import 'resources/styles/glider-extra.css';
const DynamicGlider = dynamic(() => import('react-glider'), {
  ssr: false
});
const ChevronStack = props => {
  return /*#__PURE__*/React.createElement(View, {
    $base: {
      display: 'none'
    },
    $sm: {
      display: 'none'
    },
    $md: {
      display: 'none'
    },
    $lg: {
      display: 'initial'
    },
    position: "absolute",
    left: props.left === null ? null : props.left,
    right: props.right === null ? null : props.right,
    zIndex: 999,
    bg: "rgba(0,0,0,0.5)",
    height: 96,
    width: 96,
    onPress: props.onPress,
    nativeID: props.nativeID,
    style: {
      cursor: 'pointer'
    }
  }, props.children);
};
function CardCarousel(props) {
  const [allowRouteChange, setAllowRouteChange] = useState(true);
  const [isClient, setIsClient] = useState(false);
  const r = useRef(null);
  const iconSize = 96;
  useEffect(() => {
    setIsClient(true);
  }, []);
  const slugifiedCat = slugify(props.articleGroup.category);
  const renderCards = () => /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center"
  }, props.articleGroup.data.map((article, index) => /*#__PURE__*/React.createElement(View, {
    key: index + '-main-' + slugifiedCat,
    p: 8,
    width: "20%"
  }, /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    allowRouteChange: allowRouteChange,
    article: article
  })))));
  if (!isClient) {
    return renderCards();
  }
  return /*#__PURE__*/React.createElement(Stack, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(ChevronStack, {
    nativeID: slugifiedCat + '-prev',
    left: 0
  }, /*#__PURE__*/React.createElement(EvilChevronLeft, {
    size: iconSize,
    lightColor: "white"
  })), /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(DynamicGlider, {
    ref: r,
    hasArrows: true,
    hasDots: false,
    scrollLock: true,
    draggable: true,
    duration: 0.4,
    rewind: true,
    responsive: [{
      breakpoint: 0,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 560,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 870,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 1430,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3
      }
    }],
    arrows: {
      prev: '#' + slugifiedCat + '-prev',
      next: '#' + slugifiedCat + '-next'
    }
  }, props.articleGroup.data.map((article, index) => /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    allowRouteChange: allowRouteChange,
    article: article,
    key: index + '-main-' + slugifiedCat
  }))))), /*#__PURE__*/React.createElement(ChevronStack, {
    nativeID: slugifiedCat + '-next',
    right: 0
  }, /*#__PURE__*/React.createElement(EvilChevronRight, {
    size: iconSize,
    lightColor: "white"
  })));
}
export default CardCarousel;